import styled from "styled-components";
import {Col} from 'antd';
import { SectionTopHeading } from "../../../../../../CommonComponents/commonStyles";

export const InvestmentPerformanceDiv = styled.div`
  border-bottom: 2px solid #9b9b9b;
  margin-bottom: 50px;
  position: relative;
  overflow: hidden;
`;
export const PerformanceData = styled.div`
  overflow-y: auto;
  max-height: 400px;
  .ant-progress-text {
    font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
    font-size: ${props => props.theme.fontSize.heading};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};    
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    color: ${props => props.theme.fontColors.headingColor};
  }
`;

export const TableDataHeading = styled.div`
  ${({Navigation})=>Navigation&&`
    padding-top: 7px;
  `}
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: normal;
  letter-spacing: ${props => props.theme.letterSpacing.point8};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.tertiary};
  }
`;

export const TableData = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};  
  letter-spacing: ${props => props.theme.letterSpacing.point8};
  color: ${props => props.theme.fontColors.headingColor};
  margin-top: 7px;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.tertiary};
  }
`;

export const TableCircleName = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};  
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: 20px;
`;

export const CategoryName = styled(SectionTopHeading)`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h3};
  line-height: ${props => props.theme.lineHeight.h3};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  margin: 50px 0 30px 0;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h4};
    line-height: ${props => props.theme.lineHeight.h4};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
`;

export const PerformanceCol = styled(Col)`
  margin-top: 7px;
  @media only screen and (max-width: 990px) {
    margin-top: 8px;
  }
`;